import TermList from "../AdminTermList";

export default class AdminTermListEvaluationType extends TermList {
  /**
   * @returns {string} The term type.
   */
  getType() {
    return "evaluation_type";
  }
}
